// removed by extract-text-webpack-plugin
module.exports = {"container":"audioPlayerSmall-module_container_16wYs","playButton":"audioPlayerSmall-module_playButton_37F_g","progressBarContainer":"audioPlayerSmall-module_progressBarContainer_3wq89","progressBar":"audioPlayerSmall-module_progressBar_279tw","icon":"audioPlayerSmall-module_icon_2OfgP","whiteIcon":"audioPlayerSmall-module_whiteIcon_3_GER audioPlayerSmall-module_icon_2OfgP","spinningIcon":"audioPlayerSmall-module_spinningIcon_32ro5 audioPlayerSmall-module_icon_2OfgP","spin":"audioPlayerSmall-module_spin_2kbrQ"};


//////////////////
// WEBPACK FOOTER
// ./client/components/audio/audioPlayerSmall.module.css
// module id = 295
// module chunks = 1 2 3